import React from "react";
import styled from "styled-components";
import CustomButton from "./custom-button";
import Tools from "./tools";
import Apps from "./apps";
import Account from "./account";

const NavList = styled.ul`
  display: flex;
  div[data-placement="bottom-start"] {
    z-index: 1;
  }
`;

export default () => {
  return (
    <nav role="navigation">
      <NavList>
        <li>
          <CustomButton />
        </li>
        <li>
          <Tools />
        </li>
        <li>
          <Apps />
        </li>
        <li>
          <Account />
        </li>
      </NavList>
    </nav>
  );
};
